/* Newsletter popup (sections/fj-newsletter-popup.liquid, Jenny 2026-10-07).

   Opens ONLY on demand, from anything with data-fj-newsletter-open (the
   "mailing list" words in the alert banner). It never opens by itself: an
   automatic popup was built and removed the same day, Jenny found the
   pattern "old, overused, and annoying". It also reopens on the thank-you or
   the error after Shopify reloads the page from a sign-up
   (#FjNewsletterPopup), because that is the answer to her own click. */
(function () {
  if (customElements.get('fj-newsletter-popup')) return;

  var OUT_MS = 300; /* just over the CSS close (280ms) */

  class FjNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.fj-news__dialog');
      this.email = this.querySelector('.fj-news__email');
      this.isOpen = false;
      this.onKey = this.onKey.bind(this);

      this.querySelectorAll('[data-fj-news-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      document.addEventListener('click', (event) => {
        var trigger = event.target.closest('[data-fj-newsletter-open]');
        if (!trigger) return;
        event.preventDefault();
        this.open(trigger);
      });

      /* Back from our own sign-up: show the thank-you (or the error). Shopify
         lands the page on #FjNewsletterPopup; the footer's own success line
         can also pull the scroll down, so start from the top behind it. */
      var url = new URL(window.location.href);
      if (url.hash === '#FjNewsletterPopup' && this.querySelector('[data-fj-news-state]')) {
        url.hash = '';
        url.searchParams.delete('customer_posted');
        history.replaceState(history.state, '', url.pathname + url.search);
        window.scrollTo(0, 0);
        requestAnimationFrame(() => this.open());
      }
    }

    open(trigger) {
      if (this.isOpen) return;
      clearTimeout(this.releaseTimer);
      this.isOpen = true;
      this.returnFocus = trigger || document.activeElement;

      /* Lock the page without a jolt: make up for the scrollbar's width. */
      var gap = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = gap > 0 ? gap + 'px' : '';
      document.body.style.overflow = 'hidden';

      /* Start low and small for one frame, then rise into place. Focus moves
         in only once the popup is visible: a hidden field cannot take it. */
      this.classList.add('is-entering');
      void this.offsetWidth;
      requestAnimationFrame(() => {
        this.classList.remove('is-entering');
        this.classList.add('is-open');
        this.moveFocusIn();
      });

      document.addEventListener('keydown', this.onKey);
    }

    /* Only jump into the email field with a mouse: on a phone that would
       throw the keyboard up before anyone asked for it. */
    moveFocusIn() {
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var target = fine && this.email ? this.email : this.dialog;
      if (typeof trapFocus === 'function') trapFocus(this.dialog, target);
      else target.focus({ preventScroll: true });
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this.onKey);

      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.returnFocus);
      else if (this.returnFocus && this.returnFocus.focus) this.returnFocus.focus({ preventScroll: true });

      this.releaseTimer = setTimeout(() => {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }, OUT_MS);
    }

    onKey(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      }
    }
  }

  customElements.define('fj-newsletter-popup', FjNewsletterPopup);
})();
